<template>
	<v-row>
		<v-col>
	 

				<ui-box>

					<div class="align-center d-flex justify-space-between">
						<h5>Account Management</h5>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>
					<v-row class="mb-0">
						<v-col class="text-body-2">

							<v-data-table
								hide-default-footer
								hide-default-header
							>
								<template v-slot:body>
									<tr>
										<td class="font-weight-bold table-label">Success Specialist</td>
										<td
											class="table-info"
											:class="{
													'font-italic': !successSpecialist,
													'grey--text': !successSpecialist
											}"
										>
											{{
												successSpecialist || '-'
											}}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Status</td>
										<td class="table-info">
											{{ status }}
										</td>
									</tr>
									<!-- Add more rows as needed -->
								</template>
							</v-data-table>
						</v-col>

					</v-row>
			 

				</ui-box>

				<ui-box>

					<div class="align-center d-flex justify-space-between">
						<h5>Organization Information</h5>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>
					<v-row class="mb-0">
						<v-col class="text-body-2">

							<v-data-table
								hide-default-footer
								hide-default-header
							>
								<template v-slot:body>
									<tr>
										<td class="font-weight-bold table-label">Name</td>
										<td class="table-info">
											{{ localPartner.name }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Legal Name</td>
										<td class="table-info">
											{{ localPartner.name_legal }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Organization Type</td>
										<td class="table-info">
											{{ findName(partnerTypes, localPartner.partner_type_id) }}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Contract Type</td>
										<td class="table-info">
											{{ findName(partnerContractTypes, localPartner.partner_contract_type_id) }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Region</td>
										<td class="table-info">
											{{ findName(regions, localPartner.region) }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>

					</v-row>

				</ui-box>
	 
				<ui-box>

					<div class="align-center d-flex justify-space-between">
						<h5>Payment Information</h5>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>
					<v-row class="mb-0">
						<v-col class="text-body-2">

							<v-data-table
								hide-default-footer
								hide-default-header
							>
								<template v-slot:body>
									<tr>
										<td class="font-weight-bold table-label">Gateway</td>
										<td class="table-info">
											{{ findName(gateways, localPartner.payment_gateway) }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Fee Structure</td>
										<td class="table-info">
											{{ findName(feeStructures, localPartner.partner_fee_structure_id) }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Connection</td>
										<td class="table-info">
											{{ !!paymentMethodId ? 'Connected to ' + paymentGateway.name  : 'Not Connected'}}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Annual Contract</td>
										<td class="table-info">
											{{ formatMoney(localPartner.annual_contract_value) }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Initial Contract</td>
										<td class="table-info">
											{{ formatMoney(localPartner.annual_contract_value) }}
										</td>
									</tr>
 

									<tr>
										<td class="font-weight-bold table-label">Contract Signature Date</td>
										<td class="table-info">
											{{ formatDate(localPartner.signed_at) }} 
										</td>
									</tr>
 
									<tr>
										<td class="font-weight-bold table-label">Renewal Date</td>
										<td class="table-info">
											{{ formatDate(localPartner.contract_renewal_date) }} 	
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Bandwango Creative Services</td>
										<td class="table-info">
											{{ findName(yesNo, localPartner.creative_services) }}
										</td>
									</tr>

									<tr>
										<td class="font-weight-bold table-label">Bandwango Pays Merchants</td>
										<td class="table-info">
											{{ findName(yesNo, localPartner.send_payments) }}
										</td>
									</tr>
									
								</template>
							</v-data-table>
						</v-col>

					</v-row>
				
				</ui-box>

				<ui-box>

					<div class="align-center d-flex justify-space-between">
						<h5>Primary Contact</h5>
					</div>
					<v-divider class="mb-8 mt-4 opacity-80"></v-divider>
					<v-row class="mb-0">
						<v-col class="text-body-2">
							<v-data-table
								hide-default-footer
								hide-default-header
							>
								<template v-slot:body>
									<tr>
										<td class="font-weight-bold table-label">First Name</td>
										<td class="table-info">
											{{ localPartner.primaryContact?.first_name || '-' }}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Last Name</td>
										<td class="table-info">
											{{ localPartner.primaryContact?.last_name || '-' }}
										</td>
									</tr>
									<tr>
										<td class="font-weight-bold table-label">Email</td>
										<td class="table-info">
											{{ localPartner.primaryContact?.email || '-' }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>

				</ui-box>
				<cancel-form
					:refs="$refs"
					@cancel-action="cancelChanges"
				></cancel-form>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "ViewPartner",
	props: {
		partner: {
			type: Object,
			default: () => ({ primaryContact: {} })
		},
		partnerTypes: {
			type: Array,
			default: () => []
		},
		partnerContractTypes: {
			type: Array,
			default: () => []
		},
		feeStructures: {
			type: Array,
			default: () => []
		},
		showSections: {
			type: Array,
			default: () => []
		},
		template: {
			type: Object,
			default: () => ({})
		},
		returnUrl: {
			type: String,
			default: ''
		},
		adminUsers: {
			type: Array,
			default: () => []
		},
	},
	data() {
		return {
			countries: [
				{ id: "US", name: "United States" },
				{ id: "CA", name: "Canada" },
				{ id: "GB", name: "United Kingdom" },
			],
			 
			gateways: [
				{ id: 'bandwango-stripe', name: "Bandwango Stripe" },
				{ id: 'self-stripe', name: "Partner Stripe" },
			],
			isSaving: false,
			localPartner: {
				...this.partner,
				primaryContact: {
					email: '',
					first_name: '',
					last_name: '',
					...this.partner.primaryContact
				},
			},
			phoneIsValid: true,
			regions: [
				{ id: "Pacific/Rockies", name: "Pacific/Rockies" },
				{ id: "Central", name: "Central" },
				{ id: "Northeast", name: "Northeast" },
				{ id: "Southeast", name: "Southeast" },
			],
			renewalDateModal: false,
			 
			showAddUserForm: false,
			signedDateModal: false,
			statuses: [
				{id: "active", name: "Active"},
				{id: "inactive", name: "Inactive"},
				{id: "test", name: "Test"},
			],
			yesNo: [
				{id: 1, name: "Yes"},
				{id: 0, name: "No"},
			]
		}
	},
	mounted() {
	},
	computed: {
		paymentGateway() {
			switch (this.localPartner.partner_payment_method?.payment_gateway_id
					|| this.localPartner.payment_gateway_id) {
				case 1:
					return {
						name: 'Braintree',
						image: '/images/connect-braintree.png',
					};
				case 2:
					return {
						name: 'Stripe',
						image: '/images/light-on-light@3x.png',
					};
				default:
					return {
						name: '',
						image: '',
					};
			}
		},
		paymentMethodId() {
			return this.localPartner.partner_payment_method_id || null;
		},
		successSpecialist() {
			return (this.localPartner.managers || [])[0]?.name;
		},
		status() {
			return this.findName(this.statuses, this.localPartner.status);
		},
		
	},
	methods: {

		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return `/super-admin-portal/partners/main/list-partners`;
		},
		findName(data, id) {
			return data.filter(x=>x.id == id)[0]?.name || '-';
		},
		formatDate(value) {
			return value ? value.substring(0, 10) : '-';
		},
		formatMoney(value) {
			return value ? '$ '+value : '-';
		},	
		
		shouldShowSection(section) {
			return !this.showSections.length || this.showSections.includes(section);
		},
		  
	}
};
</script>

<style lang="scss">
@use 'sass:color';

.wiz-btn-icon {
	background-color: var(--v-info-darken1) !important;
	border-radius: 50% !important;
	color: white !important;
	font-size: 28px !important;
	margin: 0 0.75rem 0 -1.5rem !important;
	padding: 0.75rem !important;
}
</style>
